import { createSelector } from 'reselect';
import { reorderFulfillmentOptionsSelector } from 'selectors/testTarget/offers/reorderFulfillmentOptions/reorderFulfillmentOptionsSelector';

const experienceSelector = createSelector(reorderFulfillmentOptionsSelector, reorderFulfillmentOptions => reorderFulfillmentOptions.experience);

export { experienceSelector };
